import React, {useState, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';
import {
    Box,
    Container,
    Avatar,
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TableFooter,
    TablePagination,
    TextField,
    Divider
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserListSkelet from '../../../skeletons/UserListSkelet';
import {useDelete, useGet} from "../../../API/request";
import {useConfirm} from "../../../components/confirm";
import {BallTriangle} from "react-loader-spinner";

const PhrasesList = () => {

    const getU = useGet();

    const [isLoaded, setIsLoaded] = useState(false);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const [phrases, setPhrases] = useState([]);
    const [languages, setLanguages] = useState([]);

    const [filterValue, setFilterValue] = useState('');

    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [count, setCount] = useState(0);

    const loadUsers = () => {
        setIsDataLoading(true);
        setIsLoaded(true)

        let endpoint = `admin/translation/phrase?page=${page + 1}&limit=${limit}`;

        if (filterValue !== '') {
            endpoint += `&value=${filterValue}`;
        }

        getU(endpoint)
            .then((resp) => {
                if (resp.status === 'success') {
                    const collator = new Intl.Collator('en');

                    setLanguages(resp?.data?.languages.sort((x, y) => {
                        return collator.compare(x.tag, y.tag);
                    }))
                    setPhrases(resp.data.phrases);
                    setCount(resp.data.allCount || 0);
                }
            })
            .catch((err) => {
                console.log(err.response)
                setPhrases([]);
                setCount(0);
            })
            .finally(() =>{
                setIsDataLoading(false);
                setIsLoaded(false)
            });


    };

    const loadUsersWithArgParams = (searchParams) => {
        setIsDataLoading(true);
        setIsLoaded(true)

        let endpoint = `admin/translation/phrase?page=${page + 1}&limit=${limit}`;

        if (searchParams.value !== '') {
            endpoint += `&value=${searchParams.email}`;
        }

        getU(endpoint)
            .then((resp) => {
                if (resp.status === 'success') {
                    setPhrases(resp.data.phrases);
                    setCount(resp.data.allCount || 0);
                }
            })
            .catch((err) => {
                console.log(err.response)
                setPhrases([]);
                setCount(0);
            })
            .finally(() =>{
                setIsDataLoading(false);
                setIsLoaded(false)
            });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeLimit = (event) => {
        setLimit(event.target.value);
        setPage(0);
    };

    const handleFilterValue = (event) => {
        setFilterValue(event.target.value);

        if (event.target.value === '') {
            loadUsersWithArgParams({
                value: '',
            });
        }
    };

    const handleFilter = () => {
        loadUsers();
    };

    useEffect(() => {
        loadUsers();
    }, [page, limit]);

    if (isLoaded) {
        return (
            <div className="loader">
                <BallTriangle
                    height="100"
                    width="100"
                    color='grey'
                    ariaLabel='loading'
                />
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>Phrases</title>
            </Helmet>

            <Box className="headerWrapper">
                <Box className="headerTitle">
                    Фразы
                </Box>
            </Box>
            <Box sx={{backgroundColor: 'background.default', minHeight: '90%', py: 3}}>
                <Container maxWidth={false}>
                    {
                        isDataLoading ?
                            <UserListSkelet/>
                            :
                            <>
                                <Box sx={{pt: 3}}>
                                    <Card>
                                        <PerfectScrollbar>
                                            <Box sx={{minWidth: 1050}}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    mx: 2,
                                                    mb: 1
                                                }}>
                                                    <TextField
                                                        fullWidth
                                                        label="Поиск по фразе"
                                                        margin="normal"
                                                        name="filterEmail"
                                                        onChange={handleFilterValue}
                                                        type="text"
                                                        value={filterValue}
                                                        variant="outlined"
                                                        style={{marginRight: 10}}
                                                    />
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={handleFilter}
                                                        sx={{mt: 2, mb: 1}}
                                                    >
                                                        Применить
                                                    </Button>
                                                </Box>
                                                <Divider/>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell >
                                                                Переводимая фраза
                                                            </TableCell>
                                                            {
                                                                languages?.map((item)=>(
                                                                    <TableCell key={item.id}>
                                                                        {
                                                                            item.tag
                                                                        }
                                                                    </TableCell>
                                                                ))
                                                            }
                                                            <TableCell>

                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {phrases?.map((item) => (
                                                            <TableRow hover key={item.id}>
                                                                <TableCell>
                                                                    {item.value}
                                                                </TableCell>
                                                                {
                                                                    Object.values(item?.languages)?.map((lang,index) =>(
                                                                        <TableCell key={index}>
                                                                            {
                                                                                lang || "---"
                                                                            }
                                                                        </TableCell>
                                                                    ))
                                                                }

                                                                <TableCell sx={{width: 100}}>
                                                                    <Link to={`/app/phrases/edit/${item.id}`}>
                                                                        <Button color="primary"
                                                                                variant="contained"
                                                                                disabled={ item?.role?.role_id === 3}
                                                                        >
                                                                            Редактирование
                                                                        </Button>
                                                                    </Link>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                labelRowsPerPage={<span>Кол-во строк на странице:</span>}
                                                                rowsPerPageOptions={[10, 20, 30, 40, 50]}
                                                                colSpan={7}
                                                                count={count}
                                                                rowsPerPage={limit}
                                                                page={page}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeLimit}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </Box>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </>
                    }
                </Container>
            </Box>
        </>
    );
};

export default PhrasesList;
